import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { ReceiptEuro } from "lucide-react";
import t from "@/lang/lang";
import { ReactNode } from "react";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { PlainTextPlugin } from "@lexical/react/LexicalPlainTextPlugin";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { useInitialConfig } from "@/services/backend/connect/components/use-initial-config";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { toast } from "sonner";

export function ConnectInvoiceExportDialog({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline">
          <ReceiptEuro />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[90vw]">
        <LexicalComposer initialConfig={useInitialConfig()}>
          <DialogHeader>
            <DialogTitle>{t("Connect Rechnungsdaten")}</DialogTitle>
            <DialogDescription>
              {t(
                "Hier können Sie die Leistungspositionen für Connect Exportieren. Sie können die Daten im Feld unten ändern. Die Änderungen gehen verloren wenn der Dialog geschlossen wird.",
              )}
            </DialogDescription>
          </DialogHeader>
          <div className="prose dark:prose-invert relative mx-auto flex w-full flex-col rounded-lg border">
            <PlainTextPlugin
              contentEditable={
                <ContentEditable className="relative h-[500px] w-full overflow-auto px-3 py-2 font-mono focus:outline-none" />
              }
              placeholder={
                <p className="text-muted-foreground pointer-events-none absolute top-0 w-full px-3 py-2">
                  Enter some text...
                </p>
              }
              ErrorBoundary={LexicalErrorBoundary}
            />
            <HistoryPlugin />
            {children}
          </div>
          <DialogFooter>
            <DialogClose asChild>
              <Button variant="outline">{t("Schließen")}</Button>
            </DialogClose>
            <CopyToClipboardButton />
          </DialogFooter>
        </LexicalComposer>
      </DialogContent>
    </Dialog>
  );
}

function CopyToClipboardButton() {
  const [editor] = useLexicalComposerContext();

  const copyToClipboard = async () => {
    const text = editor.getEditorState().read(() => {
      const root = $getRoot();
      return root.getTextContent();
    });

    await navigator.clipboard.writeText(text);
    toast.success("Inhalt in Zwischenablage kopiert");
  };

  return (
    <Button onClick={copyToClipboard}>{t("In Zwischenablage kopieren")}</Button>
  );
}
